import React, { useState } from "react";
import { DPButton } from "Components/DP";
import ReportTerminationModal from "../ReportTerminationModal/ReportTermintaionModal";
import ReportTerminationContext from "../ReportTerminationModal/ReportTerminationContext";

type Props = {
  partnerCanceledAt: string | null;
};

const AccountDetailsUserInteraction = ({ partnerCanceledAt }: Props) => {
  const isTerminated = !!partnerCanceledAt;
  const [isTerminationModalOpen, setIsTerminationModalOpen] = useState(false);

  const toggleTerminationModal = () => {
    setIsTerminationModalOpen(!isTerminationModalOpen);
  };

  return (
    <>
      <DPButton
        align="right"
        id={"terminate-employee-button"}
        onClick={toggleTerminationModal}
        disabled={isTerminated}
      >
        report termination
      </DPButton>

      <ReportTerminationContext>
        <ReportTerminationModal
          isOpen={isTerminationModalOpen}
          onClose={toggleTerminationModal}
        />
      </ReportTerminationContext>
    </>
  );
};

export default AccountDetailsUserInteraction;
